export enum REFUND_REQUEST_TYPE {
  DAILY = 100, // 주차권
  // MONTHLY = 110, // 월정기권
  //   AUTOPAY = 120, // 자동결제
  PERIOD = 130, //단기권
  SHARE = 200, // 공유주차
  ON_SITE_PAID = 300 // 현장결제
}

export enum REFUND_REQUEST_TYPE_TEXT {
  DAILY = '주차권',
  // MONTHLY = '월정기권',
  //   AUTOPAY = '자동결제',
  PERIOD = '단기권',
  SHARE = '공유주차',
  ON_SITE_PAID = '현장결제'
}

export enum REFUND_REQUEST_STATUS {
  REQUESTED = 100, // 환불 신청
  RECEIVED = 150, // 환불 접수
  COMPLETED = 200, // 환불 완료
  TRANSFER_REQUESTED = 300, // 이체 요청
  TRANSFER_RECEIVED = 310, // 이체 접수
  CLOSED = 900, // 환불 종료
  WAITING_FOR_RETRY = 910 // 재시도 요청
}
export enum REFUND_REQUEST_STATUS_TEXT {
  REQUESTED = '환불신청',
  RECEIVED = '확인중',
  COMPLETED = '환불완료',
  TRANSFER_REQUESTED = '이체요청',
  TRANSFER_RECEIVED = '이체접수',
  CLOSED = '환불반려',
  WAITING_FOR_RETRY = '재접수요청'
}

export enum REFUND_REQUEST_STATUS_TEXT_MY_TICKET {
  REQUESTED = '환불 신청',
  RECEIVED = '환불 확인 중',
  COMPLETED = '환불 완료',
  TRANSFER_REQUESTED = '이체 요청',
  TRANSFER_RECEIVED = '이체 접수',
  CLOSED = '환불 반려',
  WAITING_FOR_RETRY = '환불 재접수 요청'
}

export enum REFUND_REFUNDABLE_TYPE {
  //   AUTOPAY = 'A', // 자동 결제
  PARTNER = 'P', // 주차권
  SHARE = 'S' // 공유 주차
  //   POINT = 'CP' // 충전금
}

export enum REFUND_REQUEST_TEMPLATE {
  NONE = 'NONE', // 템플릿 없음
  ACCOUNT_ONLY = 'ACCOUNT_ONLY', // 계좌정보만 요구 (deprecated)
  ONSITEPAID_ACCOUNT = 'ONSITEPAID_ACCOUNT', // 현장 결제 계좌 정보
  ONSITEPAID_CARD_NO = 'ONSITEPAID_CARD_NO', // 현장결제 카드 정보(카드번호 포함)
  ONSITEPAID_CARD_NOEX = 'ONSITEPAID_CARD_NOEX', // 현장결제 카드 정보(카드번호 및 유효기간 포함)
  ONSITEPAID_CARD_NOAP = 'ONSITEPAID_CARD_NOAP', // 현장결제 카드 정보(카드번호 및 승인번호 포함)
  ONSITEPAID_CARD_AP = 'ONSITEPAID_CARD_AP', // 현장결제 카드 정보 (승인번호 포함)
  SHARE_UNABLE = 'SHARE_UNABLE' // 공유주차 불가
}
